import { isRejected } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI, UnknownAction } from '@reduxjs/toolkit';

import { createLoggers } from '@highlight-cp/logger';

const { warn } = createLoggers({ tag: 'RTK Query' });

interface ActionPayload extends UnknownAction {
  payload: {
    message: string;
    [k: string]: unknown;
  };
}

const isActionWithMessage = (action: unknown): action is ActionPayload => {
  return !!(action as ActionPayload).payload?.message;
};

const getRtkQueryEndpoint = (action: UnknownAction): string | undefined => {
  return (action.meta as { arg?: { endpointName?: string } } | undefined)?.arg?.endpointName;
};

export const rtkQueryErrorLogger: Middleware = (_api: MiddlewareAPI) => (next) => (action) => {
  if (!isActionWithMessage(action)) {
    return next(action);
  }

  const endpoint = getRtkQueryEndpoint(action);

  if (isRejected(action)) {
    warn('API error', {
      event: 'api error',
      message: action.payload?.message,
      type: action.type,
      endpoint,
    });
  }

  return next(action);
};
